/* ============================================================
   Sorelle theme — behavior
   Drawers, tabs, carousels, variant picker, AJAX cart.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- helpers ---------- */
  // Tracks the buyer's presentment currency (USD, AUD, GBP…). Updated from /cart.js.
  var activeCurrency = window.cartCurrency || null;

  // Settings-authored amounts (free-shipping / free-gift thresholds) are in the SHOP
  // currency, but /cart.js totals arrive in the buyer's presentment currency. Shopify
  // injects the conversion rate on every storefront page (window.Shopify.currency.rate);
  // convert before comparing or formatting, else "$50" reads as 50 CAD/EUR/….
  function convertThreshold(cents) {
    var r = window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate);
    return (r && isFinite(r) && r > 0) ? Math.round(cents * r) : cents;
  }

  // "$" is shared by USD, AUD, CAD, MXN… — suffix the ISO code only for non-USD
  // dollar currencies. Unique symbols (€, £, ¥) and USD render bare.
  // Keep in sync with snippets/price.liquid, which applies the same rule server-side.
  function needsIsoSuffix(cur, formatted) {
    if (!cur || cur === 'USD') return false;
    return formatted.replace(/[\d.,\s ]/g, '') === '$';
  }

  function legacyFormatMoney(cents) {
    var format = window.moneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    if (format.indexOf('amount_no_decimals') !== -1) amount = Math.round(cents / 100).toString();
    if (format.indexOf('amount_with_comma_separator') !== -1) amount = amount.replace('.', ',');
    var out = format.replace(/\{\{\s*\w+\s*\}\}/, amount);
    return needsIsoSuffix(activeCurrency, out) ? out + ' ' + activeCurrency : out;
  }

  function formatMoney(cents, currency) {
    var cur = currency || activeCurrency;
    if (!cur || typeof Intl === 'undefined' || !Intl.NumberFormat) return legacyFormatMoney(cents);
    try {
      var out = new Intl.NumberFormat('en', {
        style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol'
      }).format(cents / 100);
      return needsIsoSuffix(cur, out) ? out + ' ' + cur : out;
    } catch (e) {
      try {
        var out2 = new Intl.NumberFormat('en', { style: 'currency', currency: cur }).format(cents / 100);
        return needsIsoSuffix(cur, out2) ? out2 + ' ' + cur : out2;
      } catch (e2) {
        return legacyFormatMoney(cents);
      }
    }
  }

  /* ---------- drawers ---------- */
  // Pinning body with position:fixed loses the scroll position, so stash and restore it.
  var savedScrollY = 0;
  function syncDrawerLock() {
    var anyOpen = !!document.querySelector('.drawer.is-open');
    var locked = document.body.classList.contains('drawer-open');
    if (anyOpen && !locked) {
      savedScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      document.body.style.top = -savedScrollY + 'px';
      document.body.classList.add('drawer-open');
    } else if (!anyOpen && locked) {
      document.body.classList.remove('drawer-open');
      document.body.style.top = '';
      window.scrollTo(0, savedScrollY);
    }
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      var which = opener.getAttribute('data-drawer-open');
      var drawer = document.getElementById('Drawer-' + which);
      if (drawer) drawer.classList.add('is-open');
      syncDrawerLock();
      if (which === 'cart') refreshCart();
      return;
    }
    if (e.target.closest('[data-drawer-close]') || e.target.classList.contains('drawer__overlay')) {
      var open = e.target.closest('.drawer');
      if (open) open.classList.remove('is-open');
      syncDrawerLock();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); });
      syncDrawerLock();
    }
  });

  /* ---------- localization (country/currency) ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-localization-select]');
    if (sel && sel.form) sel.form.submit();
  });

  /* ---------- tabs ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-tab-target]');
    if (!btn) return;
    var scope = btn.closest('[data-tabs]');
    if (!scope) return;
    var target = btn.getAttribute('data-tab-target');
    scope.querySelectorAll('[data-tab-target]').forEach(function (b) {
      b.classList.toggle('is-active', b === btn);
    });
    scope.querySelectorAll('[data-tab-panel]').forEach(function (p) {
      p.hidden = p.getAttribute('data-tab-panel') !== target;
    });
  });

  /* ---------- carousels ---------- */
  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('[data-carousel-prev], [data-carousel-next]');
    if (!arrow) return;
    var carousel = arrow.closest('[data-carousel]');
    var track = carousel && carousel.querySelector('.carousel__track');
    if (!track) return;
    var dir = arrow.hasAttribute('data-carousel-prev') ? -1 : 1;
    track.scrollBy({ left: dir * track.clientWidth * 0.95, behavior: 'smooth' });
  });
  // disable prev/next when there is nothing left to scroll in that direction
  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('.carousel__track');
    var prev = carousel.querySelector('[data-carousel-prev]');
    var next = carousel.querySelector('[data-carousel-next]');
    if (!track || (!prev && !next)) return;
    function syncArrows() {
      var max = track.scrollWidth - track.clientWidth;
      var x = track.scrollLeft;
      if (prev) prev.disabled = x <= 1;
      if (next) next.disabled = x >= max - 1;
    }
    track.addEventListener('scroll', syncArrows, { passive: true });
    window.addEventListener('resize', syncArrows);
    // images can change scrollWidth after load
    window.addEventListener('load', syncArrows);
    syncArrows();
  });

  // dots follow scroll position
  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('.carousel__track');
    // dots may live inside the carousel (trust row) or beside it (testimonials, goals)
    var dots = carousel.querySelectorAll('[data-carousel-dot]');
    if (!dots.length && carousel.parentElement) dots = carousel.parentElement.querySelectorAll('[data-carousel-dot]');
    if (!track || !dots.length) return;

    // Nearest slide by offset, not scrollLeft/clientWidth — cards can be narrower than the track.
    // offsetLeft is relative to the offsetParent, so normalize against the first slide.
    function slidePos(i) {
      if (!track.children[i] || !track.children[0]) return 0;
      return track.children[i].offsetLeft - track.children[0].offsetLeft;
    }
    function activeIndex() {
      var best = 0, bestDist = Infinity;
      for (var i = 0; i < track.children.length; i++) {
        var dist = Math.abs(slidePos(i) - track.scrollLeft);
        if (dist < bestDist) { bestDist = dist; best = i; }
      }
      return best;
    }
    function syncDots() {
      var i = activeIndex();
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
    }
    track.addEventListener('scroll', syncDots, { passive: true });
    dots.forEach(function (d, di) {
      d.addEventListener('click', function () { track.scrollTo({ left: slidePos(di), behavior: 'smooth' }); });
    });
    syncDots();
  });

  /* ---------- carousel autoplay (opt-in: data-carousel-autoplay="<ms>") ---------- */
  document.querySelectorAll('[data-carousel][data-carousel-autoplay]').forEach(function (carousel) {
    var track = carousel.querySelector('.carousel__track');
    if (!track || track.children.length < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var delay = parseInt(carousel.getAttribute('data-carousel-autoplay'), 10) || 5000;
    var timer = null;

    // Cards can be narrower than the track, so step by slide offset, not by track width.
    function slidePos(i) {
      if (!track.children[i] || !track.children[0]) return 0;
      return track.children[i].offsetLeft - track.children[0].offsetLeft;
    }
    function activeIndex() {
      var best = 0, bestDist = Infinity;
      for (var i = 0; i < track.children.length; i++) {
        var dist = Math.abs(slidePos(i) - track.scrollLeft);
        if (dist < bestDist) { bestDist = dist; best = i; }
      }
      return best;
    }
    function advance() {
      var max = track.scrollWidth - track.clientWidth;
      // once the last card is fully in view, wrap back to the first
      var next = track.scrollLeft >= max - 1 ? 0 : activeIndex() + 1;
      track.scrollTo({ left: slidePos(next), behavior: 'smooth' });
    }
    function start() { stop(); timer = setInterval(advance, delay); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    // Pause while the user is reading or dragging; resume when they let go.
    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);
    carousel.addEventListener('pointerdown', stop, { passive: true });
    carousel.addEventListener('pointerup', start, { passive: true });
    carousel.addEventListener('touchend', start, { passive: true });
    start();
  });

  /* ---------- image strip slider (arrows + centered highlight) ---------- */
  document.querySelectorAll('[data-strip]').forEach(function (strip) {
    var track = strip.querySelector('[data-strip-track]') || strip.querySelector('.carousel__track');
    if (!track || !track.children.length) return;
    var cards = track.children;
    function update() {
      var mid = track.scrollLeft + track.clientWidth / 2;
      var best = 0, bestDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var cCenter = cards[i].offsetLeft + cards[i].offsetWidth / 2;
        var d = Math.abs(cCenter - mid);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      for (var j = 0; j < cards.length; j++) cards[j].classList.toggle('is-active', j === best);
    }
    function step(dir) {
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      track.scrollBy({ left: dir * (cards[0].offsetWidth + gap), behavior: 'smooth' });
    }
    var prev = strip.querySelector('[data-strip-prev]');
    var next = strip.querySelector('[data-strip-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', update, { passive: true });
    update();
  });

  /* ---------- track order lookup ---------- */
  document.querySelectorAll('[data-track-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input[name="tracking"]');
      var base = form.getAttribute('data-track-url') || '';
      var num = input && input.value ? input.value.trim() : '';
      if (!num || !base) return;
      window.open(base + encodeURIComponent(num), '_blank', 'noopener');
    });
  });

  /* ---------- stats rings: draw the arc when scrolled into view ---------- */
  document.querySelectorAll('[data-stat-ring]').forEach(function (ring) {
    var bar = ring.querySelector('.stat-ring__bar');
    if (!bar) return;
    var pct = parseFloat(ring.getAttribute('data-pct'));
    if (isNaN(pct)) pct = 100;
    pct = Math.max(0, Math.min(100, pct));
    var circumference = 2 * Math.PI * 42; // must match r="42" in the markup
    var target = circumference * (1 - pct / 100);

    bar.style.strokeDasharray = circumference;
    bar.style.strokeDashoffset = circumference; // start empty

    if (!('IntersectionObserver' in window)) { bar.style.strokeDashoffset = target; return; }
    var rio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        bar.style.strokeDashoffset = target;
        rio.unobserve(ring); // animate once
      });
    }, { threshold: 0.4 });
    rio.observe(ring);
  });

  /* ---------- before/after slideshow ---------- */
  document.querySelectorAll('[data-ba]').forEach(function (root) {
    var track = root.querySelector('[data-ba-track]');
    if (!track || !track.children.length) return;
    var total = track.children.length;
    var countEl = root.querySelector('[data-ba-count]');
    function index() { return Math.round(track.scrollLeft / track.clientWidth); }
    function update() { if (countEl) countEl.textContent = (index() + 1) + ' / ' + total; }
    function go(i) {
      var n = (i % total + total) % total;
      track.scrollTo({ left: track.clientWidth * n, behavior: 'smooth' });
    }
    var prev = root.querySelector('[data-ba-prev]');
    var next = root.querySelector('[data-ba-next]');
    if (prev) prev.addEventListener('click', function () { go(index() - 1); });
    if (next) next.addEventListener('click', function () { go(index() + 1); });
    track.addEventListener('scroll', update, { passive: true });
    update();
  });

  /* ---------- video loading spinner ---------- */
  document.querySelectorAll('.steps-video[data-video-wrap]').forEach(function (wrap) {
    var v = wrap.querySelector('video');
    if (!v) { wrap.classList.add('is-loaded'); return; }
    function loaded() { wrap.classList.add('is-loaded'); }
    function loading() { wrap.classList.remove('is-loaded'); }
    if (v.readyState >= 3) loaded();
    ['canplay', 'playing', 'loadeddata'].forEach(function (ev) { v.addEventListener(ev, loaded); });
    ['waiting', 'stalled'].forEach(function (ev) { v.addEventListener(ev, loading); });
  });

  /* ---------- autoplay videos when in viewport ---------- */
  var autoVids = document.querySelectorAll('.steps-video video, [data-autoplay-video] video');
  if (autoVids.length && 'IntersectionObserver' in window) {
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else { v.pause(); }
      });
    }, { threshold: 0.5 });
    autoVids.forEach(function (v) { vio.observe(v); });
  }

  /* ---------- mini reviews (autoplay carousel, 5s) ---------- */
  document.querySelectorAll('[data-mini-reviews]').forEach(function (root) {
    var track = root.querySelector('[data-mr-track]');
    var dots = root.querySelectorAll('[data-mr-dot]');
    if (!track || track.children.length < 2) return;
    var count = track.children.length;
    var index = 0, timer = null;
    function sync() {
      index = Math.round(track.scrollLeft / track.clientWidth);
      for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-active', i === index);
    }
    function go(i) {
      index = (i % count + count) % count;
      track.scrollTo({ left: track.clientWidth * index, behavior: 'smooth' });
    }
    function start() { stop(); timer = setInterval(function () { go(index + 1); }, 5000); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    track.addEventListener('scroll', sync, { passive: true });
    dots.forEach(function (d, di) { d.addEventListener('click', function () { go(di); start(); }); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('touchstart', stop, { passive: true });
    root.addEventListener('touchend', start, { passive: true });

    // mouse drag-to-scroll (desktop); touch uses native swipe
    var down = false, moved = false, startX = 0, startScroll = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      down = true; moved = false; startX = e.clientX; startScroll = track.scrollLeft;
      stop(); track.setPointerCapture(e.pointerId); track.style.cursor = 'grabbing';
    });
    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      track.scrollLeft = startScroll - dx;
    });
    function endDrag() {
      if (!down) return;
      down = false; track.style.cursor = 'grab';
      go(Math.round(track.scrollLeft / track.clientWidth));
      start();
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);

    if (dots[0]) dots[0].classList.add('is-active');
    start();
  });

  /* ---------- product form (variant cards + AJAX add) ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var idInput = form.querySelector('[name="id"]');
    var priceOut = form.querySelector('[data-atc-price]');
    var cards = form.querySelectorAll('.variant-card');

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        cards.forEach(function (c) { c.classList.remove('is-selected'); });
        card.classList.add('is-selected');
        if (idInput) idInput.value = card.getAttribute('data-variant-id');
        var price = parseInt(card.getAttribute('data-variant-price'), 10) || 0;
        var compare = parseInt(card.getAttribute('data-variant-compare'), 10) || 0;
        if (priceOut) priceOut.textContent = formatMoney(price);
        var sPrice = document.querySelector('[data-sticky-price]');
        var sCompare = document.querySelector('[data-sticky-compare]');
        if (sPrice) sPrice.textContent = formatMoney(price);
        if (sCompare) {
          if (compare > price) { sCompare.textContent = formatMoney(compare); sCompare.hidden = false; }
          else sCompare.hidden = true;
        }
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var stickyBtn = document.querySelector('[data-sticky-add]');
      if (btn) { btn.setAttribute('disabled', 'disabled'); btn.classList.add('is-loading'); }
      if (stickyBtn) stickyBtn.setAttribute('disabled', 'disabled');
      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw new Error(data.description || data.message || 'Could not add to cart.');
            return data;
          });
        })
        .then(function () { return refreshCart(); })
        .then(function () {
          var drawer = document.getElementById('Drawer-cart');
          if (drawer && drawer.getAttribute('data-auto-open') !== 'false') { drawer.classList.add('is-open'); syncDrawerLock(); }
        })
        .catch(function (err) { alert(err && err.message ? err.message : 'Could not add to cart.'); })
        .finally(function () {
          if (btn) { btn.removeAttribute('disabled'); btn.classList.remove('is-loading'); }
          if (stickyBtn) stickyBtn.removeAttribute('disabled');
        });
    });
  });

  /* ---------- AJAX cart drawer ---------- */
  var TRASH_SVG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14"/><path d="M10 11v6M14 11v6"/></svg>';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function sizedImage(url, size) {
    if (!url) return '';
    return url.replace(/(\.[a-zA-Z]+)(\?|$)/, '_' + size + 'x$1$2');
  }

  // /cart.js omits compare_at_price, so pull it from /products/{handle}.js (cached).
  var productCache = {};
  function getProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (productCache[handle]) return productCache[handle];
    var root = window.routes.root_url || '/';
    if (root.slice(-1) !== '/') root += '/';
    productCache[handle] = fetch(root + 'products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return productCache[handle];
  }

  function compareMapFor(cart) {
    var handles = [];
    cart.items.forEach(function (it) {
      if (it.handle && handles.indexOf(it.handle) === -1) handles.push(it.handle);
    });
    return Promise.all(handles.map(getProduct)).then(function (products) {
      var map = {};
      products.forEach(function (p) {
        if (!p || !p.variants) return;
        p.variants.forEach(function (v) {
          if (v.compare_at_price) map[v.id] = v.compare_at_price;
        });
      });
      return map;
    });
  }

  function updateProgress(cart) {
    var drawer = document.getElementById('Drawer-cart');
    var wrap = document.querySelector('[data-cart-progress]');
    var giftPanel = document.querySelector('[data-gift-panel]');
    if (!drawer) return;
    // Milestones are cart totals (cents): free shipping at shipT, free gift at giftT.
    // giftBlocked = Shopify refused the gift here (market restriction / out of stock),
    // so drop it from the UI rather than promise a gift that can never arrive.
    var giftT = giftBlocked ? 0 : convertThreshold(parseInt(drawer.getAttribute('data-gift-threshold'), 10) || 0);
    var shipT = convertThreshold(parseInt(drawer.getAttribute('data-ship-threshold'), 10) || 0);
    var total = cart.total_price;

    if (giftPanel) {
      var unlocked = giftT > 0 && total >= giftT;
      // show the teaser while locked too, so shoppers see what they're working toward
      giftPanel.hidden = !(giftT > 0 && cart.item_count > 0);
      giftPanel.classList.toggle('is-unlocked', unlocked);
      var giftHead = giftPanel.querySelector('[data-gift-head]');
      if (giftHead) {
        giftHead.textContent = unlocked
          ? 'You unlocked a Free Gift! 🎉'
          : 'Add ' + formatMoney(giftT - total) + ' to unlock Free Gift';
      }
    }

    // With no gift, free shipping becomes the end of the bar instead of a midpoint.
    var maxT = giftT || shipT;
    if (!wrap || !maxT) return;

    var fill = wrap.querySelector('[data-progress-fill]');
    if (fill) fill.style.width = Math.min(100, (total / maxT) * 100) + '%';

    wrap.querySelectorAll('.cart-progress__node').forEach(function (n) {
      var isGiftNode = n.getAttribute('data-node') === 'gift';
      n.hidden = isGiftNode && !giftT;
      var t = isGiftNode ? giftT : shipT;
      if (!t) return;
      // ship node sits at a % of the gift milestone; with no gift it owns the full bar
      if (!isGiftNode) n.style.left = giftT ? ((shipT / giftT) * 100) + '%' : '100%';
      n.classList.toggle('is-reached', total >= t);
      // Liquid renders these labels in the shop currency; overwrite with the converted amount.
      var lbl = n.querySelector('.cart-progress__label');
      if (lbl) lbl.textContent = formatMoney(t);
    });

    var msg = wrap.querySelector('[data-progress-msg]');
    if (!msg) return;
    if (giftT && total >= giftT) {
      msg.textContent = '🎉 You’ve unlocked a Free Gift';
    } else if (total >= shipT) {
      msg.textContent = giftT
        ? '🚚 Free Shipping unlocked! Spend ' + formatMoney(giftT - total) + ' more for a Free Gift'
        : '🚚 Free Shipping unlocked!';
    } else {
      msg.textContent = 'Spend ' + formatMoney(shipT - total) + ' more for Free Shipping';
    }
  }

  // Savings = full retail value of everything in the cart, minus what is actually paid.
  // Per line the retail value is the HIGHER of:
  //   - compare-at price x qty  (covers compare-at savings on the bundles)
  //   - original_line_price     (pre-discount price; covers the 100%-off free gift)
  // A $0-priced gift variant contributes via its compare-at price instead.
  function cartRetailValue(cart, compareMap) {
    var total = 0;
    cart.items.forEach(function (item) {
      var compareLine = ((compareMap && compareMap[item.variant_id]) || 0) * item.quantity;
      var originalLine = item.original_line_price || 0;
      total += Math.max(compareLine, originalLine);
    });
    return total;
  }

  function updateFooter(cart, compareMap) {
    var totalEl = document.querySelector('[data-cart-total]');
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    var retail = cartRetailValue(cart, compareMap);
    var savings = retail - cart.total_price;

    var row = document.querySelector('[data-savings-row]');
    var sEl = document.querySelector('[data-cart-savings]');
    if (sEl) sEl.textContent = '-' + formatMoney(savings);
    if (row) row.hidden = savings <= 0;
  }

  function renderCart(cart) {
    if (cart.currency) activeCurrency = cart.currency;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.setAttribute('data-count', cart.item_count);
    });

    var body = document.querySelector('[data-cart-lines]');
    var empty = document.querySelector('[data-cart-empty]');
    var footer = document.querySelector('[data-cart-footer]');
    if (!body) return;

    var hasItems = cart.item_count > 0;
    body.hidden = !hasItems;
    if (footer) footer.hidden = !hasItems;
    if (empty) empty.hidden = hasItems;
    var reassure = document.querySelector('[data-cart-reassurance]');
    if (reassure) reassure.hidden = !hasItems;
    var prog = document.querySelector('[data-cart-progress]');
    if (prog) prog.hidden = !hasItems;

    var giftId = giftVariantId();
    compareMapFor(cart).then(function (compareMap) {
    body.innerHTML = cart.items.map(function (item, i) {
      var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
        ? item.selling_plan_allocation.selling_plan.name : '';
      var img = sizedImage(item.image, 200);
      var isGift = (giftId && item.variant_id === giftId) || !!(item.properties && item.properties._free_gift);
      var isFree = item.final_line_price === 0;
      var compareLine = (compareMap[item.variant_id] || 0) * item.quantity;
      var compareShown = Math.max(compareLine, item.original_line_price);
      var showCompare = compareShown > item.final_line_price;

      return (
        '<div class="cart-line" data-line="' + (i + 1) + '">' +
          '<span class="cart-line__media media-frame">' +
            (img ? '<img src="' + esc(img) + '" alt="' + esc(item.product_title) + '">' : '') +
          '</span>' +
          '<span class="cart-line__info">' +
            '<span class="cart-line__title">' + esc(item.product_title) + '</span>' +
            (variantTitle ? '<span class="cart-line__variant">' + esc(variantTitle) + '</span>' : '') +
            (plan ? '<span class="cart-line__plan">' + esc(plan) + '</span>' : '') +
            '<span class="cart-line__row">' +
              '<span class="cart-line__prices">' +
                (showCompare ? '<s class="cart-line__compare">' + formatMoney(compareShown) + '</s>' : '') +
                '<span class="cart-line__price' + (isFree ? ' is-free' : '') + '">' + formatMoney(item.final_line_price) + '</span>' +
              '</span>' +
              (isFree || isGift ? '' :
                '<span class="qty-stepper">' +
                  '<button data-line-dec aria-label="Decrease quantity">−</button>' +
                  '<span>' + item.quantity + '</span>' +
                  '<button data-line-inc aria-label="Increase quantity">+</button>' +
                '</span>') +
            '</span>' +
          '</span>' +
          (isGift ? '' : '<button class="cart-line__remove" data-line-remove aria-label="Remove">' + TRASH_SVG + '</button>') +
        '</div>'
      );
    }).join('');
      updateFooter(cart, compareMap);
    });

    updateProgress(cart);
  }

  function fetchCart() {
    return fetch(window.routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function cartPost(url, payload) {
    return fetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      // /cart/add.js answers 4xx with a JSON body ({description}) — a resolved promise
      // with an error payload, which silently looked like success. Reject on it.
      return r.json().then(function (data) {
        if (!r.ok) throw new Error((data && (data.description || data.message)) || 'Cart request failed');
        return data;
      });
    });
  }

  // Set once Shopify rejects the gift (not sold in this market / out of stock there).
  // Sticky for the session: stops us retrying the add on every cart change, and tells
  // updateProgress to hide the gift milestone instead of dangling an unreachable reward.
  var giftBlocked = false;

  function giftVariantId() {
    var drawer = document.getElementById('Drawer-cart');
    return drawer ? (parseInt(drawer.getAttribute('data-gift-variant'), 10) || 0) : 0;
  }

  // Diagnostic: run giftDebug() in the browser console to see, in one shot, whether the
  // gift is failing on the THRESHOLD (cart hasn't reached it) or on the ADD (Shopify
  // refusing the product in this market). The two look identical from the outside.
  window.giftDebug = function () {
    var drawer = document.getElementById('Drawer-cart');
    if (!drawer) return console.warn('[giftDebug] no cart drawer on this page');
    var rawT = parseInt(drawer.getAttribute('data-gift-threshold'), 10) || 0;
    var rate = window.Shopify && window.Shopify.currency && window.Shopify.currency.rate;
    var giftId = giftVariantId();
    return fetchCart().then(function (cart) {
      var conv = convertThreshold(rawT);
      var reached = cart.total_price >= conv;
      console.log('[giftDebug]', {
        currency: cart.currency,
        shopifyRate: rate,
        thresholdShopCurrency: rawT / 100,
        thresholdLocalConverted: conv / 100,
        cartTotal: cart.total_price / 100,
        thresholdReached: reached,
        giftVariantId: giftId || '(none — Liquid emitted no id!)',
        giftBlocked: giftBlocked,
        itemsInCart: cart.items.map(function (i) {
          return { title: i.title, variant: i.variant_id, price: i.final_line_price / 100 };
        })
      });
      if (!reached) {
        console.log('[giftDebug] → VERDICT: threshold not reached yet. Need ' +
          formatMoney(conv - cart.total_price) + ' more. This is the threshold, not a bug.');
        return;
      }
      if (!giftId) {
        console.log('[giftDebug] → VERDICT: no gift variant id — check the Free gift product setting.');
        return;
      }
      // Threshold IS reached, so try the add and report exactly what Shopify says.
      console.log('[giftDebug] threshold reached — test-adding the gift…');
      return cartPost(window.routes.cart_add_url, {
        items: [{ id: giftId, quantity: 1, properties: { _free_gift: 'true' } }]
      }).then(function () {
        console.log('[giftDebug] → VERDICT: add SUCCEEDED. The gift works in this region.');
      }).catch(function (err) {
        console.log('[giftDebug] → VERDICT: Shopify REFUSED the add. Reason: ' + (err && err.message));
      });
    });
  };

  // Adds/removes the free gift as the cart crosses the gift threshold.
  // The threshold is measured on the total EXCLUDING the gift, so adding the
  // gift can never re-trigger (or un-trigger) itself.
  function syncFreeGift(cart) {
    var drawer = document.getElementById('Drawer-cart');
    if (!drawer) return Promise.resolve(cart);
    var giftT = convertThreshold(parseInt(drawer.getAttribute('data-gift-threshold'), 10) || 0);
    var giftId = giftVariantId();

    // Purge gift lines left behind by a PREVIOUS gift product. Without this, changing the
    // gift in settings strands the old one in every existing cart forever: it no longer
    // matches giftId, so nothing recognises it as a gift and nothing removes it.
    // Tagged lines are ours; an untagged $0 line is a legacy gift from before tagging.
    var stale = cart.items.filter(function (it) {
      if (giftId && it.variant_id === giftId) return false;      // the current gift — keep
      if (it.properties && it.properties._free_gift) return true; // our tag, wrong product
      return it.final_line_price === 0;                           // legacy free gift line
    });
    if (stale.length) {
      // One removal per pass; recurse to clear the rest, then fall through to normal sync.
      return cartPost(window.routes.cart_change_url, { id: stale[0].key, quantity: 0 })
        .then(syncFreeGift)
        .catch(function () { return cart; });
    }

    if (!giftT || !giftId || giftBlocked) return Promise.resolve(cart);

    var giftLine = null;
    cart.items.forEach(function (it) { if (it.variant_id === giftId) giftLine = it; });
    var totalExGift = cart.total_price - (giftLine ? giftLine.final_line_price : 0);

    if (totalExGift >= giftT && !giftLine) {
      return cartPost(window.routes.cart_add_url, {
        items: [{ id: giftId, quantity: 1, properties: { _free_gift: 'true' } }]
      })
        .then(fetchCart)
        .catch(function (err) {
          // Most common cause: the gift product isn't published to this market, or is
          // out of stock there. Shopify will keep refusing, so stop offering it here.
          giftBlocked = true;
          console.warn('[cart] free gift unavailable in this market — hiding it:', err && err.message);
          return cart;
        });
    }
    if (totalExGift < giftT && giftLine) {
      return cartPost(window.routes.cart_change_url, { id: giftLine.key, quantity: 0 })
        .catch(function () { return cart; });
    }
    if (giftLine && giftLine.quantity > 1) { // keep the gift at exactly one
      return cartPost(window.routes.cart_change_url, { id: giftLine.key, quantity: 1 })
        .catch(function () { return cart; });
    }
    return Promise.resolve(cart);
  }

  function refreshCart() {
    return fetchCart()
      .then(syncFreeGift)
      .then(function (cart) { renderCart(cart); return cart; });
  }

  // The overlay also blocks clicks, so a second +/- can't race the first request.
  var cartBusy = false;
  function setCartBusy(on) {
    cartBusy = on;
    var el = document.querySelector('[data-cart-loading]');
    if (el) el.hidden = !on;
  }

  function changeLine(line, quantity) {
    if (cartBusy) return Promise.resolve();
    setCartBusy(true);
    return fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(syncFreeGift)
      .then(renderCart)
      .finally(function () { setCartBusy(false); });
  }

  /* ---------- sticky add to cart ---------- */
  (function () {
    var bar = document.querySelector('[data-sticky-atc]');
    var mainBtn = document.querySelector('.atc-btn');
    if (!bar || !mainBtn) return;

    // Reveal only once the real button has scrolled ABOVE the viewport,
    // not when it is still below the fold on first paint.
    if ('IntersectionObserver' in window) {
      var sio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var scrolledPast = !en.isIntersecting && en.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', scrolledPast);
          bar.setAttribute('aria-hidden', scrolledPast ? 'false' : 'true');
        });
      }, { threshold: 0 });
      sio.observe(mainBtn);
    }

    var stickyBtn = bar.querySelector('[data-sticky-add]');
    if (!stickyBtn) return;

    // Add directly rather than submitting the form: requestSubmit() runs interactive
    // validation and activates the form's default button, which scrolls the page.
    stickyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var form = document.querySelector('[data-product-form]');
      var idInput = form && form.querySelector('[name="id"]');
      var id = idInput ? parseInt(idInput.value, 10) : 0;
      if (!id) return;

      function busy(on) {
        [stickyBtn, mainBtn].forEach(function (b) {
          if (!b) return;
          if (on) { b.setAttribute('disabled', 'disabled'); b.classList.add('is-loading'); }
          else { b.removeAttribute('disabled'); b.classList.remove('is-loading'); }
        });
      }
      busy(true);

      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw new Error(data.description || data.message || 'Could not add to cart.');
            return data;
          });
        })
        .then(function () { return refreshCart(); })
        .then(function () {
          var drawer = document.getElementById('Drawer-cart');
          if (drawer && drawer.getAttribute('data-auto-open') !== 'false') {
            drawer.classList.add('is-open');
            syncDrawerLock();
          }
        })
        .catch(function (err) { alert(err && err.message ? err.message : 'Could not add to cart.'); })
        .finally(function () { busy(false); });
    });
  })();

  document.addEventListener('click', function (e) {
    var lineEl = e.target.closest('.cart-line');
    if (!lineEl) return;
    var line = parseInt(lineEl.getAttribute('data-line'), 10);
    var qtyEl = lineEl.querySelector('.qty-stepper span');
    var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
    if (e.target.closest('[data-line-inc]')) changeLine(line, qty + 1);
    else if (e.target.closest('[data-line-dec]')) changeLine(line, qty - 1);
    else if (e.target.closest('[data-line-remove]')) changeLine(line, 0);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refreshCart);
  else refreshCart();
})();
